import { render, staticRenderFns } from "./SalesList.vue?vue&type=template&id=3a3a61b6&scoped=true&"
import script from "./SalesList.vue?vue&type=script&lang=js&"
export * from "./SalesList.vue?vue&type=script&lang=js&"
import style0 from "./SalesList.vue?vue&type=style&index=0&id=3a3a61b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3a61b6",
  null
  
)

export default component.exports